<template>
  <div>
    <a-tabs type="card" @change="callback">
      <a-tab-pane key="1" tab="采访列表">
        <Interview />
      </a-tab-pane>
      <!-- <a-tab-pane key="2" tab="品牌类别配置">
        Content of Tab Pane 54343543545
      </a-tab-pane> -->
    </a-tabs>
  </div>
</template>
<script>
import { ref, reactive, onMounted, toRefs } from '@vue/composition-api'
import Interview from './components/Interview/index'

export default {
  components: {
    Interview
  },
  setup (props, { root }) {
    function callback (e) {}

    return {
      callback
    }
  }
}
</script>
<style lang='less'>
.demo {
  border: 1px solid;
}
</style>
